<template>
  <b-modal ref="orgsModal" hide-footer :title="modalTitle" centered lazy scrollable @hide="hideModal">
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div v-for="item in [1, 2, 3]" :key="item" class="d-flex pt-2 px-1">
          <div class="avatar avatar-sm rounded-circle o-hidden border">
            <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
          </div>
          <div class="w-100 ml-2">
            <b-skeleton width="60%"></b-skeleton>
            <b-skeleton width="80%"></b-skeleton>
          </div>
        </div>
      </template>

      <i v-if="!orgs.length">No organization is partnered with this school.</i>
      <div v-for="org in orgs" :key="org.id" class="d-flex event-mod-item pt-2 px-1" v-else>
        <div class="avatar avatar-sm">
          <img :src="org.logo_url || DefaultImg" alt="Avatar" class="avatar-img rounded-circle" />
        </div>
        <div class="mt-2">
          <strong class="ml-2">{{ org.name }} </strong>
          <!-- <p class="ml-2 text-muted text-break">{{ org.email }}</p> -->
        </div>
      </div>
    </b-skeleton-wrapper>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { get } from 'lodash';

import DefaultImg from '@/assets/images/placeholders/cna_career.jpg';

export default {
  name: 'OrgsModal',

  components: {},

  props: {
    showModal: { type: Boolean, default: false },
    school: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      DefaultImg,

      modalTitle: '',
      orgs: [],
      isLoading: false,
    };
  },

  computed: {},

  watch: {
    showModal(value) {
      if (value) {
        this.modalTitle = `Partnered Organizations for "${this.school.name}"`;
        this.isLoading = true;
        this.$refs.orgsModal.show();
        this.fetchOrgs();
      }
    },
  },

  methods: {
    ...mapActions('organization', ['getSchPartneredOrgs']),
    get,

    hideModal() {
      this.$emit('close');
    },

    hideModalManual() {
      this.$refs.orgsModal.hide();
      this.hideModal();
    },

    async fetchOrgs() {
      this.isLoading = true;

      const res = await this.getSchPartneredOrgs({ school: this.school.id });
      this.orgs = res.data;
      this.isLoading = false;
    },
  },

  async mounted() {},
};
</script>
